(window["webpackJsonp"] = window["webpackJsonp"] || []).push([["main"],{

/***/ "./$$_lazy_route_resource lazy recursive":
/*!******************************************************!*\
  !*** ./$$_lazy_route_resource lazy namespace object ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function webpackEmptyAsyncContext(req) {
	// Here Promise.resolve().then() is used instead of new Promise() to prevent
	// uncaught exception popping up in devtools
	return Promise.resolve().then(function() {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	});
}
webpackEmptyAsyncContext.keys = function() { return []; };
webpackEmptyAsyncContext.resolve = webpackEmptyAsyncContext;
module.exports = webpackEmptyAsyncContext;
webpackEmptyAsyncContext.id = "./$$_lazy_route_resource lazy recursive";

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html":
/*!**************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html ***!
  \**************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n<div class=\"main-panels\">\n  <div class=\"main-panel\">\n    <div class=\"main-panel__header bgl\">\n      <div class=\"options\">\n        <button class=\"option\" (click)=\"showConfirm()\"><i class=\"ion-ios-save\"></i></button>\n        <button class=\"option\" (click)=\"print()\"><i class=\"ion-ios-print\"></i></button>\n      </div>\n    </div>\n    <div class=\"main-panel__body bgl\">\n      <div class=\"page\">\n        <div class=\"page__header header\">\n          <div class=\"header__group\">\n            <div class=\"header__name\">{{ dev.name }}</div>\n            <div class=\"header__surname\">{{ dev.surname }}</div>\n            <div class=\"header__tags tags\">\n              <ng-container *ngFor=\"let tag of dev.tags\">\n                <div class=\"tag\" *ngIf=\"tag.name.length\">\n                  {{ tag.name }}\n                </div>\n              </ng-container>\n            </div>\n          </div>\n          <div class=\"header__group header__group--logo\">\n            <div class=\"header__logo\">\n              <img src=\"assets/images/logo.svg\" />\n            </div>\n          </div>\n        </div>\n        <div class=\"page__bio bio\">\n          <div class=\"bio__group\">\n            <div class=\"bio__info\">\n              <div class=\"bio__title title\">{{ 'Bio' }}</div>\n              <div class=\"bio__content\">\n                {{ dev.bio }}\n              </div>\n            </div>\n          </div>\n          <div class=\"bio__group\">\n            <div class=\"radar\">\n              <app-radar [values]=\"dev.knowledge\"></app-radar>\n            </div>\n          </div>\n        </div>\n        <div class=\"page__details details\">\n          <div class=\"details__group\" *ngFor=\"let detail of dev.details\">\n            <div class=\"details__title title\">{{ detail.title }}</div>\n            <div class=\"details__content\">\n              <ng-container *ngFor=\"let param of detail.params\">\n                <div class=\"param\" *ngIf=\"param.name.length\">\n                  <div class=\"param__name\" >\n                    {{ param.name }}\n                  </div>\n                  <div class=\"param__value\">\n                    <app-standard  [value]=\"param.value + '/5'\">></app-standard>\n                  </div>\n                </div>\n              </ng-container>\n            </div>\n          </div>\n        </div>\n        <div class=\"page__skills skills\">\n          <ng-container *ngFor=\"let skill of dev.skills\">\n            <app-donut *ngIf=\"skill.name.length\" [value]=\"skill.value\" [label]=\"skill.name\" ></app-donut>\n          </ng-container>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"main-panel main-panel--medium settings-panel\">\n    <div class=\"main-panel__body\">\n      <div class=\"tabs\">\n          <div class=\"tab\" *ngFor=\"let tab of sideTabs\" [ngClass]=\"tab.active ? 'tab--active' : 'tab--inactive'\" (click)=\"setSideTab(tab)\">\n              <i class=\"tab__icon\" [ngClass]=\"tab.icon\"></i>\n              <label class=\"tab__label\">{{ tab.label }}</label>\n          </div>\n      </div>\n      <div class=\"settings\">\n        <ng-template [ngIf]=\"view === 'bio'\">\n            <div class=\"settings__title\">BIO</div>\n            <div class=\"form-group\">\n              <label>Name</label>\n              <input [(ngModel)]=\"dev.name\" type=\"text\" />\n            </div>\n            <div class=\"form-group\">\n              <label>Surname</label>\n              <input [(ngModel)]=\"dev.surname\" type=\"text\" />\n            </div>\n            <div class=\"form-group\">\n              <label>Bio</label>\n              <textarea [(ngModel)]=\"dev.bio\"></textarea>\n            </div>\n        </ng-template>\n        <ng-template [ngIf]=\"view === 'tags'\">\n            <div class=\"settings__title\">Tags</div>\n            <div class=\"form-group\" *ngFor=\"let tag of dev.tags; let i = index\">\n                <div class=\"input-group\">\n                  <input [(ngModel)]=\"dev.tags[i].name\" type=\"text\" [name]=\"'tag' + i\" />\n                  <div class=\"input-group-addon\" (click)=\"removeTag(i)\">\n                    <i class=\"ion ion-ios-trash\"></i>\n                  </div>\n                </div>\n            </div>\n            <button class=\"button\" (click)=\"addTag()\">Add tag</button>\n        </ng-template>\n        <ng-template [ngIf]=\"view === 'details'\">\n          <div class=\"detail\" *ngFor=\"let detail of dev.details; let i = index\">\n            <div class=\"settings__title\">\n                {{ detail.title }}\n            </div>\n            <div class=\"form-group\">\n              <label>Title</label>\n              <div class=\"input-group\">\n                <input [(ngModel)]=\"dev.details[i].title\" type=\"text\" [name]=\"'title-' + i\" />\n              </div>\n            </div>\n            <div class=\"separator separator--15\"></div>\n            <div class=\"form-group\">\n                <label>Params</label>\n            </div>\n            <div class=\"form-group\" *ngFor=\"let param of detail.params; let j = index\">\n                <div class=\"input-group\">\n                  <input [(ngModel)]=\"detail.params[j].name\" type=\"text\" [name]=\"'param' + j\" placeholder=\"name\" />\n                  <input [(ngModel)]=\"detail.params[j].value\" type=\"number\" [name]=\"'param' + j\" min=\"1\" max=\"5\" placehiolder=\"value\" />\n                  <div class=\"input-group-addon\" (click)=\"removeParam(i, j)\">\n                    <i class=\"ion ion-ios-trash\"></i>\n                  </div>\n                </div>\n            </div>\n            <button class=\"button\" (click)=\"addParam(i)\">Add param</button>\n            <button class=\"button\" (click)=\"removeSection(i)\">Remove section</button>\n          </div>\n          <div class=\"separator separator--15\"></div>\n          <button class=\"button\" (click)=\"addDetail()\">Add section</button>\n        </ng-template>\n        <ng-template [ngIf]=\"view === 'skills'\">\n            <div class=\"settings__title\">\n                {{ 'Skills' }}\n            </div>\n            <div class=\"form-group\" *ngFor=\"let skill of dev.skills; let i = index\">\n                <div class=\"input-group\">\n                  <input [(ngModel)]=\"dev.skills[i].name\" type=\"text\" [name]=\"'skill' + i\" placeholder=\"skill\" />\n                  <input [(ngModel)]=\"dev.skills[i].value\" type=\"number\" [name]=\"'skill-value' + i\" min=\"0\" max=\"100\" placehiolder=\"value\" />\n                  <div class=\"input-group-addon\" (click)=\"removeSkill(i)\">\n                    <i class=\"ion ion-ios-trash\"></i>\n                  </div>\n                </div>\n            </div>\n            <button class=\"button\" (click)=\"addSkill()\">Add skill</button>\n        </ng-template>\n        <ng-template [ngIf]=\"view === 'radar'\">\n          <div class=\"settings__title\">\n              {{ 'Radar' }}\n          </div>\n          <div class=\"form-group\" *ngFor=\"let knows of dev.knowledge; let i = index\">\n              <div class=\"input-group\">\n                <input [(ngModel)]=\"dev.knowledge[i].name\" type=\"text\" [name]=\"'skill' + i\" placeholder=\"radar\" />\n                <input [(ngModel)]=\"dev.knowledge[i].value\" type=\"number\" [name]=\"'skill-value' + i\" min=\"0\" max=\"100\" placehiolder=\"value\" />\n                <div class=\"input-group-addon\" (click)=\"removeKnowledge(i)\">\n                  <i class=\"ion ion-ios-trash\"></i>\n                </div>\n              </div>\n          </div>\n          <button class=\"button\" (click)=\"addKnowledge()\">Add skill</button>\n        </ng-template>\n        <ng-template [ngIf]=\"view === 'store'\">\n          <div class=\"settings__title\">\n            {{ 'Stored data' }}\n          </div>\n          <div class=\"cv-list\">\n            <div class=\"cv-list__item\" *ngFor=\"let cv of cvs\">\n              <div class=\"cv-list__name\" (click)=\"load(cv)\">{{ cv }}</div>\n              <div class=\"cv-list__remove\" (click)=\"removeCv(cv)\"><i class=\"ion-ios-trash\"></i></div>\n            </div>\n          </div>\n        </ng-template>\n      </div>\n    </div>\n  </div>\n  <div class=\"confirm confirm--filename\" *ngIf=\"confirmVisible\">\n    <div class=\"confirm__backdrop\" (click)=\"abortConfirm()\"></div>\n    <div class=\"confirm__content\">\n      <div class=\"confirm__header\">\n        <div class=\"confirm__title\">Save as</div>\n        <div class=\"confirm__close\" (click)=\"abortConfirm()\">&times;</div>\n      </div>\n      <div class=\"confirm__body\">\n        <div class=\"form-group\">\n          <label>Name</label>\n          <input class=\"form__control\" type=\"text\" [(ngModel)]='fileName' />\n        </div>\n      </div>\n      <div class=\"confirm__footer\">\n        <button (click)=\"save()\" class=\"button\">Save</button>\n        <button (click)=\"abortConfirm()\" class=\"button\">Abort</button>\n      </div>\n    </div>\n  </div>\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/core/components/donut/donut.component.html":
/*!**************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/core/components/donut/donut.component.html ***!
  \**************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/core/components/radar/radar.component.html":
/*!**************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/core/components/radar/radar.component.html ***!
  \**************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/core/components/standard/standard.component.html":
/*!********************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/core/components/standard/standard.component.html ***!
  \********************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"standard\">\n  <i class=\"standard__icon\"  ></i>\n  <svg *ngFor =\"let star of stars\" width=\"14\" height=\"18\" viewBox=\"0 0 14 18\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" xml:space=\"preserve\" xmlns:serif=\"http://www.serif.com/\" style=\"fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;\"><path [style.fill]=\"star ? '#FF1100' : '#f5f5f5'\" d=\"M5.91,0.32C6.573,-0.107 7.419,-0.107 8.082,0.32C9.445,1.198 11.762,2.689 13.052,3.519C13.637,3.896 13.992,4.55 13.992,5.252L13.992,12.002C13.992,12.705 13.637,13.359 13.052,13.735C11.762,14.566 9.445,16.057 8.082,16.935C7.419,17.362 6.573,17.362 5.91,16.935C4.547,16.057 2.23,14.566 0.94,13.735C0.354,13.359 0,12.705 0,12.002L0,5.252C0,4.55 0.354,3.896 0.94,3.519C2.23,2.689 4.547,1.198 5.91,0.32Z\" /></svg>\n</div>\n");

/***/ }),

/***/ "./node_modules/tslib/tslib.es6.js":
/*!*****************************************!*\
  !*** ./node_modules/tslib/tslib.es6.js ***!
  \*****************************************/
/*! exports provided: __extends, __assign, __rest, __decorate, __param, __metadata, __awaiter, __generator, __exportStar, __values, __read, __spread, __spreadArrays, __await, __asyncGenerator, __asyncDelegator, __asyncValues, __makeTemplateObject, __importStar, __importDefault */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__extends", function() { return __extends; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__assign", function() { return __assign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__rest", function() { return __rest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__decorate", function() { return __decorate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__param", function() { return __param; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__metadata", function() { return __metadata; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__awaiter", function() { return __awaiter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__generator", function() { return __generator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__exportStar", function() { return __exportStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__values", function() { return __values; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__read", function() { return __read; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spread", function() { return __spread; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spreadArrays", function() { return __spreadArrays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__await", function() { return __await; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncGenerator", function() { return __asyncGenerator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncDelegator", function() { return __asyncDelegator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncValues", function() { return __asyncValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__makeTemplateObject", function() { return __makeTemplateObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importStar", function() { return __importStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importDefault", function() { return __importDefault; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),

/***/ "./src/app/app.component.scss":
/*!************************************!*\
  !*** ./src/app/app.component.scss ***!
  \************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2FwcC5jb21wb25lbnQuc2NzcyJ9 */");

/***/ }),

/***/ "./src/app/app.component.ts":
/*!**********************************!*\
  !*** ./src/app/app.component.ts ***!
  \**********************************/
/*! exports provided: AppComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppComponent", function() { return AppComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _core_services_store_store_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./core/services/store/store.service */ "./src/app/core/services/store/store.service.ts");
/* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/platform-browser */ "./node_modules/@angular/platform-browser/fesm2015/platform-browser.js");
/* harmony import */ var ngx_toast_notifications__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ngx-toast-notifications */ "./node_modules/ngx-toast-notifications/fesm2015/ngx-toast-notifications.js");





var view;
(function (view) {
    view["bio"] = "bio";
    view["tags"] = "tags";
    view["details"] = "details";
    view["skills"] = "skills";
    view["radar"] = "radar";
    view["store"] = "store";
})(view || (view = {}));
let AppComponent = class AppComponent {
    constructor(store, titleService, toaster) {
        this.store = store;
        this.titleService = titleService;
        this.toaster = toaster;
        this.confirmVisible = false;
        this.fileName = '';
        this.title = 'BoostHigh CV Creator';
        this.cvs = [];
        this.dev = {
            name: 'Mirosław',
            surname: 'Technologiczny',
            // tslint:disable-next-line: max-line-length
            bio: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer ultricies mollis lacus, a pulvinar lacus efficitur vel. Aliquam maximus tincidunt nibh at posuere. Suspendisse feugiat tristique elit, eget auctor quam porta in. Duis porta metus sapien, at venenatis nunc accumsan vitae. Proin fringilla tellus tellus, quis maximus velit pellentesque id. Sed sed ante elementum felis tristique ornare sed nec velit. Morbi varius at sem sed cursus. In id vulputate sapien. Etiam et nulla a arcu congue cursus. Vivamus eget viverra dui. Nam tortor libero, dignissim at pellentesque et, vulputate fermentum massa. ',
            tags: [
                { name: 'Javascript' },
                { name: 'Typescript' }
            ],
            knowledge: [
                { name: 'Database', value: 10 },
                { name: 'Design', value: 70 },
                { name: 'Programming', value: 70 },
                { name: 'Frontend', value: 90 },
                { name: 'Backend', value: 30 },
                { name: 'Hardware', value: 50 }
            ],
            details: [
                {
                    title: 'Technologies',
                    params: [
                        { name: 'JavaScript', value: 4 },
                        { name: 'TypeScript', value: 4 }
                    ]
                },
                {
                    title: 'Software',
                    params: [
                        { name: 'Linux', value: 4 },
                        { name: 'Microsoft IIS', value: 4 }
                    ]
                }, {
                    title: 'Others',
                    params: [
                        { name: 'Microsoft IIS', value: 4 }
                    ]
                },
            ],
            skills: [
                { name: 'GIT', value: 70 },
                { name: 'Jira', value: 50 },
                { name: 'English', value: 60 },
                { name: 'Scrum', value: 60 },
            ]
        };
        this.sideTabs = [
            { label: 'Bio', icon: 'ion-ios-person', active: true, view: view.bio },
            { label: 'Tags', icon: 'ion-ios-list', active: false, view: view.tags },
            { label: 'Radar', icon: 'ion-ios-paper', active: false, view: view.radar },
            { label: 'Details', icon: 'ion-ios-star', active: false, view: view.details },
            { label: 'Skills', icon: 'ion-ios-pie', active: false, view: view.skills },
            { label: 'Saved data', icon: 'ion-ios-save', active: false, view: view.store }
        ];
        this.view = view.bio;
        this.toastConfig = {
            position: 'top-center',
            autoClose: true,
            type: 'dark',
            duration: 3000,
            preventDuplicates: true
        };
        titleService.setTitle(this.title);
    }
    abortConfirm() {
        this.confirmVisible = false;
    }
    showConfirm() {
        this.confirmVisible = true;
    }
    setSideTab(selectedTab) {
        this.sideTabs.forEach((tab) => tab.active = false);
        selectedTab.active = true;
        this.view = selectedTab.view;
    }
    addTag() {
        this.dev.tags.push({ name: '' });
    }
    removeTag(index) {
        this.dev.tags.splice(index, 1);
    }
    removeParam(detailIndex, paramIndex) {
        this.dev.details[detailIndex].params.splice(paramIndex, 1);
    }
    removeSection(sectionIndex) {
        this.dev.details.splice(sectionIndex, 1);
    }
    addParam(detailIndex) {
        this.dev.details[detailIndex].params.push({ name: '', value: 1 });
    }
    addDetail() {
        this.dev.details.push({
            title: '',
            params: [
                { name: '', value: 1 }
            ]
        });
    }
    addSkill() {
        this.dev.skills.push({ name: '', value: 20 });
    }
    removeSkill(skillIndex) {
        this.dev.skills.splice(skillIndex, 1);
    }
    addKnowledge() {
        this.dev.knowledge.push({ name: '', value: 20 });
    }
    removeKnowledge(skillIndex) {
        this.dev.knowledge.splice(skillIndex, 1);
    }
    load(cvName) {
        this.dev = JSON.parse(this.store.load(cvName));
        this.fileName = cvName;
        this.toaster.open('Loaded ' + this.fileName, this.toastConfig);
        this.titleService.setTitle(this.fileName);
    }
    save(fileName) {
        this.titleService.setTitle(this.fileName);
        const name = this.fileName ? this.fileName : this.createNeWFileName();
        this.fileName = name;
        if (!this.cvs.find(cvName => name === cvName)) {
            this.cvs.push(name);
        }
        this.store.save('cvs', JSON.stringify(this.cvs));
        this.store.save(name, JSON.stringify(this.dev));
        this.confirmVisible = false;
        this.toaster.open('Saved ' + this.fileName, this.toastConfig);
    }
    removeCv(cvName) {
        if (this.cvs.find(name => name === cvName)) {
            this.cvs.splice(this.cvs.findIndex(name => name === cvName), 1);
            this.store.remove(cvName);
        }
        this.store.save('cvs', JSON.stringify(this.cvs));
    }
    autoLoad() {
        this.cvs = this.store.load('cvs') ? JSON.parse(this.store.load('cvs')) : [];
        if (this.cvs.length) {
            const cvName = this.cvs[this.cvs.length - 1];
            this.fileName = cvName;
            this.dev = JSON.parse(this.store.load(cvName));
        }
        this.titleService.setTitle(this.fileName);
        this.toaster.open('Auto loaded ' + this.fileName, this.toastConfig);
    }
    print() {
        this.titleService.setTitle(this.fileName);
        window.print();
    }
    createNeWFileName() {
        return 'cv-' + new Date().toISOString().substr(0, 16).replace('T', '-');
    }
    ngOnInit() {
        this.autoLoad();
    }
};
AppComponent.ctorParameters = () => [
    { type: _core_services_store_store_service__WEBPACK_IMPORTED_MODULE_2__["StoreService"] },
    { type: _angular_platform_browser__WEBPACK_IMPORTED_MODULE_3__["Title"] },
    { type: ngx_toast_notifications__WEBPACK_IMPORTED_MODULE_4__["Toaster"] }
];
AppComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-root',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./app.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./app.component.scss */ "./src/app/app.component.scss")).default]
    })
], AppComponent);



/***/ }),

/***/ "./src/app/app.module.ts":
/*!*******************************!*\
  !*** ./src/app/app.module.ts ***!
  \*******************************/
/*! exports provided: AppModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppModule", function() { return AppModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/platform-browser */ "./node_modules/@angular/platform-browser/fesm2015/platform-browser.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _app_component__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./app.component */ "./src/app/app.component.ts");
/* harmony import */ var _core_components_standard_standard_module__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./core/components/standard/standard.module */ "./src/app/core/components/standard/standard.module.ts");
/* harmony import */ var _core_components_donut_donut_module__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./core/components/donut/donut.module */ "./src/app/core/components/donut/donut.module.ts");
/* harmony import */ var _core_components_radar_radar_module__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./core/components/radar/radar.module */ "./src/app/core/components/radar/radar.module.ts");
/* harmony import */ var ngx_toast_notifications__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ngx-toast-notifications */ "./node_modules/ngx-toast-notifications/fesm2015/ngx-toast-notifications.js");
/* harmony import */ var _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @angular/platform-browser/animations */ "./node_modules/@angular/platform-browser/fesm2015/animations.js");










let AppModule = class AppModule {
};
AppModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["NgModule"])({
        declarations: [
            _app_component__WEBPACK_IMPORTED_MODULE_4__["AppComponent"]
        ],
        imports: [
            _angular_platform_browser__WEBPACK_IMPORTED_MODULE_1__["BrowserModule"],
            _angular_forms__WEBPACK_IMPORTED_MODULE_3__["FormsModule"],
            _core_components_standard_standard_module__WEBPACK_IMPORTED_MODULE_5__["StandardModule"],
            _core_components_donut_donut_module__WEBPACK_IMPORTED_MODULE_6__["DonutModule"],
            _core_components_radar_radar_module__WEBPACK_IMPORTED_MODULE_7__["RadarModule"],
            _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_9__["BrowserAnimationsModule"],
            ngx_toast_notifications__WEBPACK_IMPORTED_MODULE_8__["ToastNotificationsModule"],
        ],
        providers: [],
        bootstrap: [_app_component__WEBPACK_IMPORTED_MODULE_4__["AppComponent"]],
    })
], AppModule);



/***/ }),

/***/ "./src/app/core/components/donut/donut.component.scss":
/*!************************************************************!*\
  !*** ./src/app/core/components/donut/donut.component.scss ***!
  \************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2NvcmUvY29tcG9uZW50cy9kb251dC9kb251dC5jb21wb25lbnQuc2NzcyJ9 */");

/***/ }),

/***/ "./src/app/core/components/donut/donut.component.ts":
/*!**********************************************************!*\
  !*** ./src/app/core/components/donut/donut.component.ts ***!
  \**********************************************************/
/*! exports provided: DonutComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DonutComponent", function() { return DonutComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let DonutComponent = class DonutComponent {
    constructor(elementRef) {
        this.elementRef = elementRef;
        this.value = 100;
        this.label = 'Jira';
        this.size = 150;
        this.padding = 15;
    }
    createCanvas() {
        const canvas = document.createElement('canvas');
        canvas.width = this.size;
        canvas.height = this.size;
        this.ctx = canvas.getContext('2d');
        this.elementRef.nativeElement.appendChild(canvas);
    }
    drawDonut() {
        const texts = this.label.split(' ');
        const percentage = this.value / 100;
        const startAngle = 270 * (Math.PI / 180);
        this.ctx.beginPath();
        this.ctx.arc(this.size / 2, this.size / 2, this.size / 2 - 2 * this.padding, startAngle, startAngle + 2 * Math.PI);
        this.ctx.lineWidth = 10;
        this.ctx.strokeStyle = '#f5f5f5';
        this.ctx.stroke();
        this.ctx.beginPath();
        this.ctx.arc(this.size / 2, this.size / 2, this.size / 2 - 2 * this.padding, startAngle, startAngle + percentage * 2 * Math.PI);
        this.ctx.lineWidth = 10;
        this.ctx.strokeStyle = '#ff1100';
        this.ctx.stroke();
        this.ctx.closePath();
        texts.forEach((text, index, array) => {
            this.ctx.font = '900 10px Rubik';
            this.ctx.textAlign = 'center';
            this.ctx.fillText(text.toUpperCase(), this.size / 2, this.size / 2 + (index * 10) + 5 - ((array.length - 1) * 10) / 2);
        });
    }
    redraw() {
        if (this.ctx) {
            this.ctx.clearRect(0, 0, this.size, this.size);
            this.drawDonut();
        }
    }
    ngOnChanges(changes) {
        this.redraw();
    }
    ngAfterViewInit() {
        document.fonts.ready.then(() => {
            this.createCanvas();
            this.drawDonut();
        });
    }
};
DonutComponent.ctorParameters = () => [
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ElementRef"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], DonutComponent.prototype, "value", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], DonutComponent.prototype, "label", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], DonutComponent.prototype, "size", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], DonutComponent.prototype, "padding", void 0);
DonutComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-donut',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./donut.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/core/components/donut/donut.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./donut.component.scss */ "./src/app/core/components/donut/donut.component.scss")).default]
    })
], DonutComponent);



/***/ }),

/***/ "./src/app/core/components/donut/donut.module.ts":
/*!*******************************************************!*\
  !*** ./src/app/core/components/donut/donut.module.ts ***!
  \*******************************************************/
/*! exports provided: DonutModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DonutModule", function() { return DonutModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
/* harmony import */ var _donut_component__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./donut.component */ "./src/app/core/components/donut/donut.component.ts");




let DonutModule = class DonutModule {
};
DonutModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"])({
        declarations: [_donut_component__WEBPACK_IMPORTED_MODULE_3__["DonutComponent"]],
        imports: [
            _angular_common__WEBPACK_IMPORTED_MODULE_2__["CommonModule"]
        ],
        exports: [_donut_component__WEBPACK_IMPORTED_MODULE_3__["DonutComponent"]]
    })
], DonutModule);



/***/ }),

/***/ "./src/app/core/components/radar/radar.component.scss":
/*!************************************************************!*\
  !*** ./src/app/core/components/radar/radar.component.scss ***!
  \************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2NvcmUvY29tcG9uZW50cy9yYWRhci9yYWRhci5jb21wb25lbnQuc2NzcyJ9 */");

/***/ }),

/***/ "./src/app/core/components/radar/radar.component.ts":
/*!**********************************************************!*\
  !*** ./src/app/core/components/radar/radar.component.ts ***!
  \**********************************************************/
/*! exports provided: RadarComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RadarComponent", function() { return RadarComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let RadarComponent = class RadarComponent {
    constructor(elementRef, differs) {
        this.elementRef = elementRef;
        this.differs = differs;
        this.size = 1000;
        this.padding = 400;
        this.values = [];
    }
    pointFromCenter(degrees, r) {
        const startAngle = 270;
        const angle = degrees * (Math.PI / 180) + startAngle * (Math.PI / 180);
        const center = this.size / 2;
        const x = r * Math.cos(angle) + center;
        const y = r * Math.sin(angle) + center;
        return { x, y };
    }
    drawRadar() {
        const degrees = 360 / this.values.length;
        const nets = 4;
        for (let n = 4; n > 0; n--) {
            const region = new Path2D();
            this.values.forEach((value, i) => {
                // tslint:disable-next-line: no-shadowed-variable
                let r = (this.size - this.padding) / 2;
                r = r / 1 / nets * n;
                if (i === 0) {
                    region.moveTo(this.pointFromCenter(degrees * i, r).x, this.pointFromCenter(degrees * i, r).y);
                }
                region.lineTo(this.pointFromCenter(degrees * i + degrees, r).x, this.pointFromCenter(degrees * i + degrees, r).y);
            });
            region.closePath();
            if (n === 4) {
                this.ctx.fillStyle = '#fff';
                this.ctx.fill(region, 'evenodd');
            }
            this.ctx.lineWidth = 6;
            this.ctx.setLineDash([20, 20]);
            this.ctx.strokeStyle = '#E8E8E8';
            this.ctx.stroke(region);
        }
        const chart = new Path2D();
        const r = (this.size - this.padding) / 2;
        const l = r * this.values[this.values.length - 1].value / 100;
        let x1 = this.pointFromCenter(degrees * (this.values.length - 1) + degrees, l).x;
        let y1 = this.pointFromCenter(degrees * (this.values.length - 1) + degrees, l).y;
        chart.moveTo(x1, y1);
        this.values.forEach((value, i) => {
            // tslint:disable-next-line: no-shadowed-variable
            const l = r * value.value / 100;
            chart.lineTo(this.pointFromCenter(degrees * i + degrees, l).x, this.pointFromCenter(degrees * i + degrees, l).y);
            x1 = this.pointFromCenter(degrees * i + degrees, r).x;
            y1 = this.pointFromCenter(degrees * i + degrees, r).y;
        });
        chart.closePath();
        this.ctx.lineWidth = 20;
        this.ctx.setLineDash([20, 0]);
        this.ctx.lineJoin = 'round';
        this.ctx.strokeStyle = '#ff1100';
        this.ctx.stroke(chart);
        this.ctx.closePath();
        this.values.forEach((value, i) => {
            this.ctx.beginPath();
            this.ctx.arc(this.pointFromCenter(degrees * i + degrees, r).x, this.pointFromCenter(degrees * i + degrees, r).y, 20, 0, 2 * Math.PI);
            this.ctx.fillStyle = '#ff1100';
            this.ctx.fill();
            this.ctx.strokeStyle = '#ffffff';
            this.ctx.lineWidth = 10;
            this.ctx.stroke();
            this.ctx.closePath();
            this.ctx.beginPath();
            this.ctx.font = '900 30px Rubik';
            const p = r + 50;
            this.ctx.fillStyle = '#000';
            let textAlign = 'center';
            const x = this.pointFromCenter(degrees * i + degrees, p).x;
            if (Math.round(x) > Math.round(this.size / 2)) {
                textAlign = 'start';
            }
            if (Math.round(x) < Math.round(this.size / 2)) {
                textAlign = 'end';
            }
            this.ctx.textAlign = textAlign;
            this.ctx.fillText(value.name.toUpperCase(), x, this.pointFromCenter(degrees * i + degrees, p).y);
            this.ctx.closePath();
        });
    }
    createCanvas() {
        const canvas = document.createElement('canvas');
        canvas.width = this.size;
        canvas.height = this.size;
        this.ctx = canvas.getContext('2d');
        this.elementRef.nativeElement.appendChild(canvas);
    }
    redraw() {
        if (this.ctx) {
            this.ctx.clearRect(0, 0, this.size, this.size);
            this.drawRadar();
        }
    }
    ngAfterViewInit() {
        document.fonts.ready.then(() => {
            this.createCanvas();
            this.drawRadar();
        });
    }
    ngDoCheck() {
        const changes = this.differs.find(this.values);
        if (changes) {
            this.redraw();
        }
    }
};
RadarComponent.ctorParameters = () => [
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ElementRef"] },
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["IterableDiffers"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], RadarComponent.prototype, "size", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], RadarComponent.prototype, "padding", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], RadarComponent.prototype, "values", void 0);
RadarComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-radar',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./radar.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/core/components/radar/radar.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./radar.component.scss */ "./src/app/core/components/radar/radar.component.scss")).default]
    })
], RadarComponent);



/***/ }),

/***/ "./src/app/core/components/radar/radar.module.ts":
/*!*******************************************************!*\
  !*** ./src/app/core/components/radar/radar.module.ts ***!
  \*******************************************************/
/*! exports provided: RadarModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RadarModule", function() { return RadarModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
/* harmony import */ var _radar_component__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./radar.component */ "./src/app/core/components/radar/radar.component.ts");




let RadarModule = class RadarModule {
};
RadarModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"])({
        declarations: [_radar_component__WEBPACK_IMPORTED_MODULE_3__["RadarComponent"]],
        imports: [
            _angular_common__WEBPACK_IMPORTED_MODULE_2__["CommonModule"]
        ],
        exports: [_radar_component__WEBPACK_IMPORTED_MODULE_3__["RadarComponent"]]
    })
], RadarModule);



/***/ }),

/***/ "./src/app/core/components/standard/standard.component.scss":
/*!******************************************************************!*\
  !*** ./src/app/core/components/standard/standard.component.scss ***!
  \******************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".standard svg {\n  margin-right: 5px;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3JhZGVrL1Byb2pla3R5L2Jvb3N0aGlnaC1jdi9zcmMvYXBwL2NvcmUvY29tcG9uZW50cy9zdGFuZGFyZC9zdGFuZGFyZC5jb21wb25lbnQuc2NzcyIsInNyYy9hcHAvY29yZS9jb21wb25lbnRzL3N0YW5kYXJkL3N0YW5kYXJkLmNvbXBvbmVudC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUNJO0VBQU8saUJBQUE7QUNDWCIsImZpbGUiOiJzcmMvYXBwL2NvcmUvY29tcG9uZW50cy9zdGFuZGFyZC9zdGFuZGFyZC5jb21wb25lbnQuc2NzcyIsInNvdXJjZXNDb250ZW50IjpbIi5zdGFuZGFyZCB7XG4gICAgc3ZnICB7IG1hcmdpbi1yaWdodDogNXB4OyB9XG59XG4iLCIuc3RhbmRhcmQgc3ZnIHtcbiAgbWFyZ2luLXJpZ2h0OiA1cHg7XG59Il19 */");

/***/ }),

/***/ "./src/app/core/components/standard/standard.component.ts":
/*!****************************************************************!*\
  !*** ./src/app/core/components/standard/standard.component.ts ***!
  \****************************************************************/
/*! exports provided: StandardComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StandardComponent", function() { return StandardComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let StandardComponent = class StandardComponent {
    constructor() {
        this.value = '0/10';
    }
    getFullStars() {
        if (this.value) {
            const full = Number(this.value.split('/')[0]);
            return full;
        }
    }
    getMaxStars() {
        if (this.value) {
            const max = Number(this.value.split('/')[1]);
            return max;
        }
    }
    generateStars() {
        this.stars = [];
        const full = this.getFullStars();
        const max = this.getMaxStars();
        const empty = max - full;
        for (let i = 0; i < full; i++) {
            this.stars.push(true);
        }
        for (let i = 0; i < empty; i++) {
            this.stars.push(false);
        }
    }
    ngOnInit() {
        this.generateStars();
    }
    ngOnChanges(p) {
        this.generateStars();
    }
};
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], StandardComponent.prototype, "value", void 0);
StandardComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-standard',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./standard.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/core/components/standard/standard.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./standard.component.scss */ "./src/app/core/components/standard/standard.component.scss")).default]
    })
], StandardComponent);



/***/ }),

/***/ "./src/app/core/components/standard/standard.module.ts":
/*!*************************************************************!*\
  !*** ./src/app/core/components/standard/standard.module.ts ***!
  \*************************************************************/
/*! exports provided: StandardModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StandardModule", function() { return StandardModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
/* harmony import */ var _standard_component__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./standard.component */ "./src/app/core/components/standard/standard.component.ts");




let StandardModule = class StandardModule {
};
StandardModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"])({
        declarations: [_standard_component__WEBPACK_IMPORTED_MODULE_3__["StandardComponent"]],
        imports: [
            _angular_common__WEBPACK_IMPORTED_MODULE_2__["CommonModule"]
        ],
        exports: [_standard_component__WEBPACK_IMPORTED_MODULE_3__["StandardComponent"]]
    })
], StandardModule);



/***/ }),

/***/ "./src/app/core/services/store/store.service.ts":
/*!******************************************************!*\
  !*** ./src/app/core/services/store/store.service.ts ***!
  \******************************************************/
/*! exports provided: StoreService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StoreService", function() { return StoreService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let StoreService = class StoreService {
    constructor() {
        this.storage = window.localStorage;
    }
    save(key, value) {
        this.storage.setItem(key, value);
    }
    load(key) {
        return this.storage.getItem(key);
    }
    remove(key) {
        this.storage.removeItem(key);
    }
};
StoreService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    })
], StoreService);



/***/ }),

/***/ "./src/environments/environment.ts":
/*!*****************************************!*\
  !*** ./src/environments/environment.ts ***!
  \*****************************************/
/*! exports provided: environment */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "environment", function() { return environment; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

const environment = {
    production: false
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.


/***/ }),

/***/ "./src/main.ts":
/*!*********************!*\
  !*** ./src/main.ts ***!
  \*********************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_platform_browser_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/platform-browser-dynamic */ "./node_modules/@angular/platform-browser-dynamic/fesm2015/platform-browser-dynamic.js");
/* harmony import */ var _app_app_module__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./app/app.module */ "./src/app/app.module.ts");
/* harmony import */ var _environments_environment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./environments/environment */ "./src/environments/environment.ts");





if (_environments_environment__WEBPACK_IMPORTED_MODULE_4__["environment"].production) {
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["enableProdMode"])();
}
Object(_angular_platform_browser_dynamic__WEBPACK_IMPORTED_MODULE_2__["platformBrowserDynamic"])().bootstrapModule(_app_app_module__WEBPACK_IMPORTED_MODULE_3__["AppModule"])
    .catch(err => console.error(err));


/***/ }),

/***/ 0:
/*!***************************!*\
  !*** multi ./src/main.ts ***!
  \***************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! /home/radek/Projekty/boosthigh-cv/src/main.ts */"./src/main.ts");


/***/ })

},[[0,"runtime","vendor"]]]);
//# sourceMappingURL=main-es2015.js.map